export default "__VITE_ASSET__V1evQnio__"